<template>
    <div class="mb-5 mb-xl-8 card">
        <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
                <span class="card-label fw-bolder fs-3 mb-1">{{ $t("pages.usefulTraining.title") }}</span>
            </h3>
            <div class="align-items-end flex-column">
                <a href="#" @click="this.initAdd" class="btn btn-primary btn-light btn-active-light-primary" data-bs-toggle="modal" data-bs-target="#kt_modal_1">{{
                    $t("pages.usefulTraining.addTraining")
                }}</a>
            </div>
        </div>
        <div class="card-body py-3">
            <div class="table-responsive">
                <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                    <thead>
                        <tr class="fw-bolder text-muted">
                            <th class="min-w-150px">{{ $t("pages.usefulTraining.trainingName") }}</th>
                            <th class="min-w-150px">{{ $t("pages.usefulTraining.link") }}</th>
                            <th class="min-w-100px text-end">{{ $t("pages.usersList.actions") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="usefulTraining in usefulTrainings" v-bind:key="usefulTraining.pk">
                            <td>
                                <a href="#" class="text-dark fw-bolder text-hover-primary fs-6">{{ usefulTraining.label }}</a>
                            </td>
                            <td>
                                <a href="#" class="text-dark fw-bolder text-hover-primary fs-6">{{ usefulTraining.link }}</a>
                            </td>
                            <td class="text-end">
                                <a
                                    @click="this.initEdit(usefulTraining)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#kt_modal_1"
                                    class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                >
                                    <span class="svg-icon svg-icon-3"
                                        ><svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                xmlns="http://www.w3.org/2000/svg"
                                                opacity="0.3"
                                                d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z"
                                                fill="black"
                                            ></path>
                                            <path
                                                xmlns="http://www.w3.org/2000/svg"
                                                d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z"
                                                fill="black"
                                            ></path></svg></span></a
                                ><a @click="this.deleteUsefulTraining(usefulTraining)" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                                    ><span class="svg-icon svg-icon-3"
                                        ><svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                xmlns="http://www.w3.org/2000/svg"
                                                d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                                                fill="black"
                                            ></path>
                                            <path
                                                xmlns="http://www.w3.org/2000/svg"
                                                opacity="0.5"
                                                d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                                                fill="black"
                                            ></path>
                                            <path
                                                xmlns="http://www.w3.org/2000/svg"
                                                opacity="0.5"
                                                d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                                                fill="black"
                                            ></path></svg></span
                                ></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="modal fade" tabindex="-1" id="kt_modal_1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t("pages.usefulTraining.addEditTraining") }}</h5>

                    <!--begin::Close-->
                    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                        <span class="svg-icon svg-icon-2x"></span>
                    </div>
                    <!--end::Close-->
                </div>

                <div class="modal-body">
                    <Form id="kt_add_action_form" class="form" novalidate="novalidate">
                        <div class="row mb-6">
                            <!--begin::Label-->
                            <label class="col-lg-12 col-form-label required fw-bold fs-6">{{ $t("pages.usefulTraining.trainingName") }}</label>
                            <!--end::Label-->

                            <!--begin::Col-->
                            <div class="col-lg-12">
                                <!--begin::Row-->
                                <div class="row">
                                    <!--begin::Col-->
                                    <div class="col-lg-12 fv-row">
                                        <Field
                                            type="text"
                                            class="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
                                            :placeholder="$t('pages.usefulTraining.trainingName')"
                                            name="categoryLabel"
                                            v-model="this.usefulTraining.label"
                                        ></Field>
                                    </div>
                                    <!--end::Col-->
                                </div>
                                <!--end::Row-->
                            </div>
                            <!--end::Col-->
                        </div>
                        <div class="row mb-6">
                            <!--begin::Label-->
                            <label class="col-lg-12 col-form-label required fw-bold fs-6">{{ $t("pages.usefulTraining.trainingLink") }}</label>
                            <!--end::Label-->

                            <!--begin::Col-->
                            <div class="col-lg-12">
                                <!--begin::Row-->
                                <div class="row">
                                    <!--begin::Col-->
                                    <div class="col-lg-12 fv-row">
                                        <Field
                                            type="text"
                                            class="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
                                            :placeholder="$t('pages.usefulTraining.trainingLink')"
                                            name="categoryLabel"
                                            v-model="this.usefulTraining.link"
                                        ></Field>
                                    </div>
                                    <!--end::Col-->
                                </div>
                                <!--end::Row-->
                            </div>
                            <!--end::Col-->
                        </div>
                    </Form>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-light" data-bs-dismiss="modal">{{ $t("general.close") }}</button>
                    <button type="button" @click="addUsefulTraning" id="kt_account_profile_details_submit" ref="submitButton" class="btn btn-primary">
                        <span class="indicator-label"> {{ $t("general.add") }} </span>
                        <span class="indicator-progress">
                            {{ $t("general.pleaseWait") }}
                            <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                        <span class="indicator-validate">
                            {{ $t("general.done") }}
                            <span class="fas fa-check f-5 ms-3"></span>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import usefulTrainingApi from "@/core/services/UsefulTraining";
import { Field } from "vee-validate";
import { useI18n } from "vue-i18n";
import buttonHandle from "@/shared.js";

export default defineComponent({
    name: "administration-usefultraining",
    components: { Field },
    data: function () {
        return {
            usefulTraining: {
                id: null,
                label: "",
                link: "",
            },
            usefulTrainings: [],
        };
    },
    methods: {
        addUsefulTraning() {
            buttonHandle.handleWaitingButton(this.submitButton);
            if (this.usefulTraining.id) {
                usefulTrainingApi.updateUsefulTraining(this.usefulTraining.id, this.usefulTraining).then(() => {
                    buttonHandle.handleValidatedButton(this.submitButton);
                    setTimeout(() => {
                        location.reload();
                    }, 500);
                });
            } else {
                usefulTrainingApi.addUsefulTraining(this.usefulTraining).then(() => {
                    buttonHandle.handleValidatedButton(this.submitButton);
                    setTimeout(() => {
                        location.reload();
                    }, 500);
                });
            }
        },
        deleteUsefulTraining(usefulTraining) {
            usefulTrainingApi.deleteUsefulTraining(usefulTraining.pk).then(() => {
                location.reload();
            });
        },
        initEdit(usefulTraining) {
            this.usefulTraining = {
                id: usefulTraining.pk,
                label: usefulTraining.label,
                link: usefulTraining.link,
            };
        },
        initAdd() {
            this.usefulTraining = {
                id: null,
                label: "",
                link: "",
            };
        },
        getUsefulTraining() {
            usefulTrainingApi.getUsefulTraining().then((response) => {
                this.usefulTrainings = response.data["usefultrainings"];
            });
        },
    },
    setup() {
        const { t } = useI18n();
        setCurrentPageBreadcrumbs(t("pages.usefulTraining.management"), []);
        const submitButton = ref<HTMLElement | null>(null);
        return { t, submitButton };
    },
    watch: {
        "$i18n.locale": function () {
            setCurrentPageBreadcrumbs(this.t("pages.usefulTraining.management"), []);
        },
    },
    created() {
        this.getUsefulTraining();
    },
});
</script>
